/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ApplicationContext } from '@/state/providers';
import Button from '@/components/atoms/Button';
import BurgerMenuItem from '@/components/layouts/BurgerMenuItem';
import Explore from '@/components/atoms/Icon/Explore';
import { ClearMemory } from '@/components/utils/DeviceUtils';

import './BurgerMenu.scss';

const propTypes = {
    closeOverlay: PropTypes.func,
};

const defaultProps = {
    closeOverlay: () => {},
};

const BurgerMenu = (props) => {
    const { closeOverlay } = props;
    const [data] = useContext(ApplicationContext);
    const menu = data?.header.menu;

    const onMenuItemClick = () => {
        closeOverlay();
        ClearMemory(true);
    };

    return (
        <div className="BurgerMenu">
            <div className="BurgerMenu__gradient-top" />
            <div className="BurgerMenu__header">
                <Link to="/#exterior" onClick={onMenuItemClick}>
                    <Button className="BurgerMenu__view-exterior" largeHitbox="right" variant="icon-light" icon={<Explore />} type="button">
                        {menu?.text.cta.viewExterior}
                    </Button>
                </Link>
            </div>
            <div className="BurgerMenu__items">
                {menu?.items
                    && menu.items.map((item, index) => {
                        const active = window.location.href.indexOf(item.route) !== -1;

                        const cta = {
                            route: item.route,
                            text: active ? item.text.cta.continue : item.text.cta.start,
                        };

                        // eslint-disable-next-line  no-prototype-builtins
                        const submenu = item.hasOwnProperty('submenu') && item.submenu != null ? item.submenu : [];

                        return (
                            <div className="BurgerMenu__item" key={index}>
                                <BurgerMenuItem
                                    title={item.text.title}
                                    submenu={submenu}
                                    subtext={menu.text.move}
                                    cta={cta}
                                    active={active}
                                    ctaCallback={onMenuItemClick}
                                    submenuheading={menu.text.submenuheading}
                                />
                            </div>
                        );
                    })}
            </div>
            <div className="BurgerMenu__footer" />
            <div className="BurgerMenu__gradient-bottom" />
        </div>
    );
};

BurgerMenu.propTypes = propTypes;
BurgerMenu.defaultProps = defaultProps;

export default BurgerMenu;
